(ns common.announcement.queries
  "React Query definitions for portal announcements."
  (:require [cljs-bean.core :refer [->clj]]
            [clojure.string :as str]
            [common.queries.http :as qhttp]
            [medley.core :as medley]))

(defn- parse-announcement [^js announcement]
  (-> (->clj announcement)
      (medley/update-existing :routes (fn [routes]
                                        (into #{}
                                              (map #(let [[namespace route] (-> % (str/replace #":" "") (str/split "/"))]
                                                      (keyword namespace route)))
                                              routes)))))

(def latest-announcement-query
  #js {:queryKey #js ["portal-latest-announcement"]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/announcements-latest {})))
       :select parse-announcement
       :staleTime (* 1 60 60 1000)  ; 1 hour
       })
